import { forwardRef } from 'react';
import { NumberInput } from '@/components/molecules/NumberInput';
import { cn } from '@/lib/utils';

interface PercentInputProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type' | 'onChange' | 'value'
> {
  value: number | '';
  onChange: (value: number | '') => void;
}

export const PercentInput = forwardRef<HTMLInputElement, PercentInputProps>(
  ({ value, onChange, className, ...props }, ref) => {
    return (
      <div className="relative">
        <NumberInput
          {...props}
          ref={ref}
          min={0}
          max={100}
          step="any"
          // The typed text lives in NumberInput, so an emptied box stays empty
          // and a part-typed "12." keeps its trailing dot instead of being
          // rewritten from the parsed number on the next render.
          value={value === '' ? null : value}
          onChange={(next) => onChange(next ?? '')}
          className={cn('pr-6', className)}
        />
        <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
          %
        </span>
      </div>
    );
  },
);
PercentInput.displayName = 'PercentInput';
